import TimerfastIcon from '@ordr-as/icons/TimerfastIcon';
import { useNow } from '../../../hooks/useNow';
import { formatClock, isWarnAge } from '../utils';

type Props = {
  createdUtc: string | undefined;
};

// Owns its own clock so only the elapsed-time badge re-renders on the tick — never the board above it.
const CardHeadTime = ({ createdUtc }: Props) => {
  const nowMs = useNow();
  const clock = formatClock(createdUtc);
  if (!clock) return null;

  const warn = isWarnAge(createdUtc, nowMs);
  return (
    <span
      className={`ml-auto flex items-center gap-1 text-small font-semibold whitespace-nowrap ${
        warn ? 'text-orange-darkest' : 'text-grey-dark'
      }`}
    >
      {warn && <TimerfastIcon width={14} height={14} />}
      {clock}
    </span>
  );
};

export default CardHeadTime;
